import store from '@/store'

export default{
  inserted (el, binding, vnode) {
    const { value } = binding
    const permissionNames = store.state.user && store.state.user.info.user_info.permission_name

    if (value && value instanceof Array && value.length > 0) {
      const curNames = value

      const hasPermission = permissionNames.some(p => {
        return curNames.includes(p)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need permission names! Like v-permission="['admin','editor']"`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/permission.js